<div class="title p-3">
    <div class="row">
        <div class="col d-flex justify-content-start align-items-center">
            <h1 class="mx-1">
                <span>
                    Info Push Notification  #{{pushNotification?.id_push}}
                </span>
                <button type="button" class="btn btn-small btn-primary" (click)="getRequestInfo()">
                    <i class="fa-solid fa-arrows-rotate"></i>
                    <span> Reîncarcă informații</span>
                </button>
            </h1>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn">
                <mat-icon (click)="closeDialog()">close</mat-icon>
            </button>
        </div>
    </div>
</div>
<div class="row p-4 responsive-content">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-9">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-sm-6">
                            <h4 style="margin-top: 7px;" class="border-bottom border-blue">
                                Push Info
                            </h4>
                            <table class="table cetatean-table">
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="header">Titlu</td>
                                        <td>{{pushNotification?.title}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">Mesaj</td>
                                        <td>{{pushNotification?.message}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">Push Data</td>
                                        <td>{{pushNotification?.schedule_date}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">Procesat?</td>
                                        <td>
                                            <span *ngIf="pushNotification?.processed == 2">Success</span>
                                            <span *ngIf="pushNotification?.processed == 1">Pending</span>
                                            <span *ngIf="pushNotification?.processed == 0 || pushNotification?.processed == null">Neprocesat</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="header">Active</td>
                                        <td>
                                            <span *ngIf="pushNotification?.active == 1">ACTIV</span>
                                            <span *ngIf="pushNotification?.active == 0">INACTIV</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="header">Mobile View</td>
                                        <td>
                                            <span *ngIf="pushNotification?.public_view == 1">ACTIV</span>
                                            <span *ngIf="pushNotification?.public_view == 0">INACTIV</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="header">Excerpt</td>
                                        <td>{{pushNotification?.excerpt}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">Observații</td>
                                        <td>{{pushNotification?.observatii}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">Content</td>
                                        <td [innerHTML]="pushNotification?.content"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <h4 style="margin-top: 7px;" class="border-bottom border-blue">Device-uri</h4>
                            <table class="table cetatean-table">
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="header">Vizitatori unici mesaj App</td>
                                        <td>{{pushNotification?.unique_views}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">Vizitatori total mesaj App</td>
                                        <td>{{pushNotification?.count_views}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">Android Device-uri receptionaț</td>
                                        <td>{{pushNotification?.android_recipients}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">Android Device-uri total</td>
                                        <td>{{pushNotification?.android_total_users}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">iOS Device-uri receptionaț</td>
                                        <td>{{pushNotification?.ios_recipients || '0'}}</td>
                                    </tr>
                                    <tr>
                                        <td class="header">iOS Device-uri total</td>
                                        <td>{{pushNotification?.ios_total_users || '0'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <h4 class="border-bottom border-blue d-flex justify-content-between align-items-center">
                    Galerie
                    <button type="button" class="btn btn-primary btn-lg pull-right" (click)="openAddDialog()">
                        Adaugă
                    </button>
                </h4>
                <hr/>
                <div class="row">
                    <div class="col-sm-12">
                        <div>
                            <div *ngFor="let image of pushNotification?.gallery_list" class="imageGalleryItem actionOnHover">
                                <img *ngIf="imageUrls[image.id]" class="product-image img-responsive" [src]="imageUrls[image.id]" />
                                <mat-spinner class="d-flex justify-content-center align-items-center" *ngIf="!imageUrls[image.id]" color="primary" diameter="50"></mat-spinner>
                                <div class="actionButtons">
                                    <button (click)="openViewDialog(imageUrls[image.id])" class="viewButton detailsButton"><i class="fa fa-eye"></i></button>
                                    <button (click)="deleteImage(image.id)" class="deleteButton detailsButton"><i class="fa fa-trash"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 class="border-bottom border-blue mt-2">Activități Utilizatori App Mobile</h4>
            </div>
        </div>
    </div>
</div>
<div class="section-spinner position-fixed" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <img src="assets/icons/logo-ps4-icon.svg" height="50%" width="50%" alt="PS4" />
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>